// https://soneium.blockscout.com/address/0xD92b37a5114b33F668D274Fb48f23b726a854d6E
export const CROSS_CHAIN_CONTROLLER = '0xD92b37a5114b33F668D274Fb48f23b726a854d6E';

// IPayloadsControllerCore https://soneium.blockscout.com/address/0x44D73D7C4b2f98F426Bf8B5e87628d9eE38ef0Cf
export const PAYLOADS_CONTROLLER = '0x44D73D7C4b2f98F426Bf8B5e87628d9eE38ef0Cf';

// https://soneium.blockscout.com/address/0xd0929668178973d5994D5654929aCB3d6c2b9949
export const PC_DATA_HELPER = '0xd0929668178973d5994D5654929aCB3d6c2b9949';

// https://soneium.blockscout.com/address/0xD8E6956718784B914740267b7A50B952fb516656
export const GRANULAR_GUARDIAN = '0xD8E6956718784B914740267b7A50B952fb516656';

// https://soneium.blockscout.com/address/0x19CE4363FEA478Aa04B9EA2937cc5A2cbcD44be6
export const GOVERNANCE_GUARDIAN = '0x19CE4363FEA478Aa04B9EA2937cc5A2cbcD44be6';

// https://soneium.blockscout.com/address/0x47aAdaAE1F05C978E6aBb7568d11B7F6e0FC4d6A
export const EXECUTOR_LVL_1 = '0x47aAdaAE1F05C978E6aBb7568d11B7F6e0FC4d6A';

export const CHAIN_ID = 1868;
